import { createStore } from "vuex";
import alarmModule from "./modules/alarm/index.js";
import applicationModule from "./modules/application/index.js";
import appStoreModule from "./modules/appStore/index.js";
import bannedUserModule from "./modules/bannedUser/index.js";
import captchaModule from "./modules/captcha/index.js";
import engagementActiveEmojiModule from "./modules/engagementActiveEmoji/index.js";
import engagementAnswerGalleryModule from "./modules/engagementAnswerGallery/index.js";
import engagementCategoryModule from "./modules/engagementCategory/index.js";
import engagementCategoryTitleRuleModule from "./modules/engagementCategoryTitleRule/index.js";
import engagementFeedApproveModule from "./modules/engagementFeedApprove/index.js";
import engagementFeederTypeModule from "./modules/engagementFeederType/index.js";
import engagementInformationTemplateTopicModule from "./modules/engagementInformationTemplateTopic/index.js";
import engagementModerationReasonModule from "./modules/engagementModerationReason/index.js";
import engagementQueueModule from "./modules/engagementQueue/index.js";
import engagementQueueRuleModule from "./modules/engagementQueueRule/index.js";
import engagementSpellCheckDictionaryModule from "./modules/engagementSpellCheckDictionary/index.js";
import engagementTemplateModule from "./modules/engagementTemplate/index.js";
import engagementUnmaskFeedTitleModule from "./modules/engagementUnmaskFeedTitle/index.js";
import engagementWorkingHourModule from "./modules/engagementWorkingHour/index.js";
import executiveModule from "./modules/executive/index.js";
import executiveDashboardModule from "./modules/executiveDashboard/index.js";
import facebookModule from "./modules/facebook/index.js";
import feedModule from "./modules/feed/index.js";
import feedApprove from "./modules/feedApprove/index.js";
import feedArchiveModule from "./modules/feedArchive/index.js";
import feedAttachmentModule from "./modules/feedAttachment/index.js";
import feedCategories from "./modules/feedCategories/index.js";
import feedDetailModule from "./modules/feedDetail/index.js";
import feederModule from "./modules/feeder/index.js";
import feederProfilePanelModule from "./modules/feederProfilePanel/index.js";
import feedFilterModule from "./modules/feedFilter/index.js";
import feedQueueModule from "./modules/feedQueue/index.js";
import feedShareModule from "./modules/feedShare/index.js";
import fileexport from "./modules/fileexport/index.js";
import fileUpload from "./modules/fileUpload/index.js";
import googlePlayModule from "./modules/googlePlay/index.js";
import instagramModule from "./modules/instagram/index.js";
import keywordModule from "./modules/keyword/index.js";
import languageModule from "./modules/language/index.js";
import layoutModule from "./modules/layout/index.js";
import linkedinModule from "./modules/linkedin/index.js";
import operationalMonitoringModule from "./modules/operationalMonitoring/index.js";
import operationFeedModule from "./modules/operationFeed/index.js";
import queueModule from "./modules/operationQueue/index.js";
import operationRecentActionModule from "./modules/operationRecentAction/index.js";
import reportModule from "./modules/report/index.js";
import sikayetvarModule from "./modules/sikayetvar/index.js";
import sniffdeckModule from "./modules/sniffdeck/index.js";
import sourceModule from "./modules/source/index.js";
import superUserFaqModule from "./modules/superUserFaq/index.js";
import superUserGnipArchiveDisconnectionModule from "./modules/superUserGnipArchiveDisconnection/index.js";
import superUserManuelAccountCollectModule from "./modules/superUserManuelAccountCollect/index.js";
import superUserOperationModule from "./modules/superUserOperation/index.js";
import superUserSearchTweetModule from "./modules/superUserSearchTweet/index.js";
import superUserWorkspaceModule from "./modules/superUserWorkspace/index.js";
import superUserXStreamModule from "./modules/superUserXStream/index.js";
import tagModule from "./modules/tag/index.js";
import tiktokModule from "./modules/tiktok/index.js";
import twitterModule from "./modules/twitter/index.js";
import userModule from "./modules/user/index.js";
import workspaceModule from "./modules/workspace/index.js";
import workspaceGroupModule from "./modules/workspaceGroup/index.js";
import workspaceUserModule from "./modules/workspaceUser/index.js";
import youtubeModule from "./modules/youtube/index.js";




import dashboardModule from './modules/dashboard/index.js';



import engagementFeedSendPrivateModule from "./modules/engagementFeedSendPrivate/index.js";
import engagementWorkspaceAiModule from "./modules/engagementWorkspaceAi/index.js";
import faqsModule from "./modules/Faq/index.js";
import operationTabModule from "./modules/operationTab/index.js";

const store = createStore({
    modules: {
        tag: tagModule,
        faqs: faqsModule,
        user: userModule,
        feed: feedModule,
        alarm: alarmModule,
        queue: queueModule,
        feeder: feederModule,
        source: sourceModule,
        tiktok: tiktokModule,
        layout: layoutModule,
        fileExport: fileexport,
        fileUpload: fileUpload,
        captcha: captchaModule,
        keyword: keywordModule,
        youtube: youtubeModule,
        twitter: twitterModule,
        feedApprove: feedApprove,
        linkedin: linkedinModule,
        language: languageModule,
        facebook: facebookModule,
        sniffdeck: sniffdeckModule,
        workspace: workspaceModule,
        instagram: instagramModule,
        executive: executiveModule,
        feedQueue: feedQueueModule,
        feedShare: feedShareModule,
        googlePlay: googlePlayModule,
        sikayetvar: sikayetvarModule,
        bannedUser: bannedUserModule,
        feedFilter: feedFilterModule,
        feedDetail: feedDetailModule,
        feedArchive: feedArchiveModule,
        application: applicationModule,
        appStore: appStoreModule,
        workspaceUser: workspaceUserModule,
        operationFeed: operationFeedModule,
        feedAttachment: feedAttachmentModule,
        workspaceGroup: workspaceGroupModule,
        engagementQueue: engagementQueueModule,
        recentAction: operationRecentActionModule,
        executiveDashboard: executiveDashboardModule,
        engagementTemplate: engagementTemplateModule,
        engagementQueueRule: engagementQueueRuleModule,
        engagementFeederType: engagementFeederTypeModule,
        engagementActiveEmoji : engagementActiveEmojiModule,
        engagementModerationReason: engagementModerationReasonModule,
        engagementInformationTemplateTopic: engagementInformationTemplateTopicModule,
        engagementSpellCheckDictionary: engagementSpellCheckDictionaryModule,
        engagementFeedApprove: engagementFeedApproveModule,
        engagementFeedSendPrivate: engagementFeedSendPrivateModule,
        engagementWorkspaceAi: engagementWorkspaceAiModule,
        engagementCategory: engagementCategoryModule,
        engagementCategoryTitleRule: engagementCategoryTitleRuleModule,
        engagementAnswerGallery: engagementAnswerGalleryModule,
        engagementWorkingHour: engagementWorkingHourModule,
        engagementUnmaskFeedTitle: engagementUnmaskFeedTitleModule,
        feedCategories: feedCategories,
        superUserOperation: superUserOperationModule,
        superUserFaq: superUserFaqModule,
        superUserWorkspace: superUserWorkspaceModule,
        superUserGnipArchiveDisconnection: superUserGnipArchiveDisconnectionModule,
        superUserManuelAccountCollect: superUserManuelAccountCollectModule,
        superUserSearchTweet: superUserSearchTweetModule,
        superUserXStream: superUserXStreamModule,
        feederProfilePanel: feederProfilePanelModule,           
        report: reportModule,
        operationalMonitoring: operationalMonitoringModule,
        dashboard: dashboardModule,
        operationTab: operationTabModule
    }
});

export default store;